import { fetchApi } from "../../../lib/fetchApi";
import { KeyValuePair } from "../../../types/KeyValuePair";
import { ClaimFileDto, GenerateTextDto, LoadDocumentClaim } from "../types";

const BASE_URL = "/claimFile"

export const loadDocument = async (body: LoadDocumentClaim): Promise<ClaimFileDto[]> => {
    
    const formData = new FormData();
    
    const files: File[] = Array.isArray(body.files) 
        ? body.files 
        : body.files 
            ? [body.files] 
            : [];

    if (files.length === 0) {
        throw new Error("At least one file is required");
    }

    files.forEach((file) => formData.append('File', file));
    formData.append('ClaimId', body.claimId?.toString() ?? "");

    const response = await fetchApi.post(`${BASE_URL}/load`, formData) as ClaimFileDto[];

    return response;
};

export const loadDocumentComment = async (body: LoadDocumentClaim): Promise<ClaimFileDto[]> => {
    
    const formData = new FormData();
    
    const files: File[] = Array.isArray(body.files) 
        ? body.files 
        : body.files 
            ? [body.files] 
            : [];

    if (files.length === 0) {
        throw new Error("At least one file is required");
    }

    files.forEach((file) => formData.append('File', file));
    formData.append('ClaimId', body.claimId?.toString() ?? "");

    const response = await fetchApi.post(`${BASE_URL}/load/comment`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    }) as ClaimFileDto[];

    return response;
};

export const updateClaimFile = async (fileId: string, body: ClaimFileDto): Promise<void> => {
    await fetchApi.put(`${BASE_URL}/${fileId}`, body) as ClaimFileDto;
}

export const deleteClaimFile = async (fileId: string): Promise<void> => {
    await fetchApi.put(`${BASE_URL}/delete/${fileId}`, null) as ClaimFileDto;
}

export const downloadClaimFile = async (idClaim: number): Promise<ClaimFileDto> => {
    const response = await fetchApi.get(`${BASE_URL}/download/${idClaim}`) as ClaimFileDto;
    return response;
}

export const summaryClaimFile = async (fileId: string): Promise<GenerateTextDto> => {
   const response =  await fetchApi.get(`${BASE_URL}/summary/${fileId}`) as GenerateTextDto;
   return response;
}

export const validateIfFilesAlreadyExistInClaim = async (claimId: number, files: File[]): Promise<KeyValuePair[]> => {
    const formData = new FormData();    
    files.forEach(file => formData.append('files', file));

    const response = await fetchApi.post<KeyValuePair[]>(`${BASE_URL}/validate-files/${claimId}`, formData);
    return response;
}